'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';

import { ResetPasswordForm } from '@/app/reset/reset-password-form';

export default function NotFound() {
  const pathname = usePathname();

  // Static export only generates /reset/index.html — when a user visits
  // /reset/TOKEN/, CloudFront serves root index.html and the client router
  // lands here. Render the reset form so the token is read from the URL.
  if (pathname?.startsWith('/reset/') && pathname !== '/reset/') {
    return <ResetPasswordForm />;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50">
      <h1 className="text-6xl font-bold text-gray-900">404</h1>
      <h2 className="mt-4 text-2xl font-medium text-gray-600">Page Not Found</h2>
      <p className="mt-2 text-gray-500">The page you are looking for does not exist.</p>
      <div className="mt-8">
        <Link
          href="/"
          className="inline-flex items-center justify-center rounded-md bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
